
export const baseUrl = "https://system.yoursummer.ly/";// LIVE
export const linksytemweb = "https://booking.yoursummer.ly/";// LIVE
//_______________________________________________________________________________
//                          Link  Test
// export const baseUrl = "https://test.yoursummer.ly/server/";// TEST
// export const linksytemweb = "https://test.yoursummer.ly/";// TEST
//_______________________________________________________________________________
//                          Link Server
// export const linksytemweb = "http://localhost:3000";// Local
// export const baseUrl = "http://localhost/YourSummer/server/";// Local

export const googleMapsApiKey = "AIzaSyAiWiRygL-zJe_GDSqBhClQ4zTC06VcOBE";
export const linkLogin = "web/API/logs/sign-in.php";
///_______________________________________________________________________________
// /                          Resorts
export const linkSetResort = "web/API/resorts/set_resort.php";
export const linkGetResorts = "web/API/resorts/get_resorts.php";
//_______________________________________________________________________________
//                          Apartments

export const getapartments_dates_coming_resort = "web/API/apartments/get_apartments_dates.php";
export const getapartment_dates_resort = "web/API/apartments/get_apartment_dates.php";
//_______________________________________________________________________________
//                          Customers
export const updatecustomer = "web/API/customers/update_customer.php";
export const deletecustomer = "web/API/customers/delete_customer.php";

export const _endPoints = {
    reservations: {
        add: "web/API/reservationes/reservation.php",
        update: "web/API/reservationes/update_reservation.php",
        delete: "web/API/reservationes/delete_reservationes.php",
        handle: "web/API/reservationes/handel_reservation.php",
        edit: "web/API/reservationes/edit_reservation.php",
        search: "web/API/reservationes/search_reservationes.php",
        get_all: "web/API/reservationes/get_reservationes.php",
        get_check_status_all: "web/API/reservationes/get_check_status_all.php",
        services: {
            get_all: "web/API/reservationes/services/get_services.php",
            booking: "web/API/reservationes/services/set_reservation.php",
            handel: "web/API/reservationes/services/handel_service.php",
            get_coming: "web/API/reservationes/services/get_reservationes_coming.php",
            get_now: "web/API/reservationes/services/get_reservationes_now.php",
            get_old: "web/API/reservationes/services/get_reservationes_old.php",
            get_del: "web/API/reservationes/services/get_reservationes_del.php",
            get_dashboard_stats: "web/API/reservationes/services/get_dashboard_stats.php",
            dashboard: "web/API/dashboard/get_dashboard_analytics.php",
            delete: "web/API/reservationes/services/delete_reservationes.php",
        },
        get_by_qrcode: "web/API/reservationes/get_by_qrcode.php",
    },
    customers: {
        insert: "web/API/customers/set_customer.php",
        page: "web/API/customers/page/index.php",
        files: baseUrl + "upload/customers/",
        get_app: 'web/API/customers/get_customers_app.php',
        update: 'web/API/customers/update_customer.php',
        getcustomers_by_name: 'web/API/customers/get_customers_by_name.php',
        delete: 'web/API/customers/delete_customer.php',
        app_update: 'web/API/customers/update_customer_app.php',
    },
    users: {
        insert: 'web/API/users/set_user.php',
        update: 'web/API/users/update_user.php',
        change_password: 'web/API/users/change_password.php',
        update_permissions: 'web/API/users/permissions/update_permissions_user.php',
        get_user_tracking: 'web/API/users/get_user_tracking.php',
        images: baseUrl + "upload/users/"
    },
    users_app: {
        get_all: 'web/API/users_app/get_users_app.php',
        get_user: 'web/API/users_app/get_user.php',
        app_update: 'web/API/users_app/update_user_app.php',
        sendWelcomePushNotification: 'web/API/users_app/send_welcome_notification.php'
    },
    permissions: {
        get_all: "web/API/users/permissions/get_permissions.php",
        my: "web/API/users/permissions/get_mypermissions.php"
    },
    resorts: {
        udpate: "web/API/resorts/update.php",
        my: "web/API/resorts/my_reosrt.php",
        images: baseUrl + "upload/resorts/"
    },
    apartments: {
        images: baseUrl + "upload/apartments/",
        get_apartment: "web/API/apartments/get_apartment.php",
        update: "web/API/apartments/update_apartment.php",
        get_apartments: "web/API/apartments/get_apartments.php",
        get_all: "web/API/apartments/get_apartments.php",
        set: "web/API/apartments/set_apartment.php",
        get_accessories: "web/API/apartments/get_accessories.php",
    },
    whatsapp: {
        new_booking: "web/API/whatsapp/new_booking.php",
        invoice_pdf: 'invoices/public/index.php',
    },
    payment: {
        get_payment_type: "web/API/reservationes/payments/get_payment_type.php",
        paid_reservationes: "web/API/reservationes/payments/paid_reservationes.php",
        handel_paid_card: "web/API/reservationes/payments/handel_paid_card.php",
        get_bank_accounts: "web/API/reservationes/payments/get_bank_accounts.php",
    }
}
export const getcustomers = "web/API/customers/get_customers.php";
export const getcities = "web/API/customers/get_cities.php";
//_______________________________________________________________________________
//                          Booking
export const sethandelbooking = "web/API/reservationes/handel_reservation.php";
export const setbooking = "web/API/reservationes/set_reservation.php";
export const getbookings = "web/API/reservationes/get_reservationes.php";
export const getbookingsnow = "web/API/reservationes/get_reservationes_now.php";
export const getbookingscheck = "web/API/reservationes/get_reservationes_check.php";
export const getbookingscoming = "web/API/reservationes/get_reservationes_coming.php";
export const getbookingsold = "web/API/reservationes/get_reservationes_old.php";
export const getbookingsdel = "web/API/reservationes/get_reservationes_del.php";
export const check_status_all = "web/API/reservationes/get_check_status_all.php";
export const update_check_status = "web/API/reservationes/update_check_status.php";

export const getsearchbookings = "web/API/reservationes/get_search_reservationes.php";
export const editbooking = "web/API/reservationes/edit_reservation.php";
//_______________________________________________________________________________
//                         Paid Booking
export const getpaymenttype = "web/API/reservationes/payments/get_payment_type.php";
export const getbankaccounts = "web/API/reservationes/payments/get_bank_accounts.php";
export const setpaidbooking = "web/API/reservationes/payments/paid_reservationes.php";
export const setpaidcardbooking = "web/API/reservationes/payments/handel_paid_card.php";
export const setdeletebooking = "web/API/reservationes/delete_reservationes.php";
//_______________________________________________________________________________
//                          Payments
export const getpaymentsdate = "web/API/reservationes/payments/get_payments_day.php";
export const getpaymentscheckin = "web/API/reports/reservationes_check_in.php";
export const getreportreservationes = "web/API/reports/report_reservationes.php";
export const getpaymentsmonth = "web/API/reservationes/payments/get_payments_month.php";
export const getpaymentsyear = "web/API/reservationes/payments/get_payments_year.php";
//_______________________________________________________________________________
//                          Dashboard
export const getdatadashboard = "web/API/home/data_dahsboard.php";
export const getbookings_checkin_today = "web/API/reservationes/get_reservationes_check_in_today.php";
export const getbookings_checkout_today = "web/API/reservationes/get_reservationes_check_out_today.php";
//_______________________________________________________________________________
//                          Users
export const getallusers = "web/API/users/get_users.php";
//_______________________________________________________________________________
//_______________________________________________________________________________
//                          Services
export const getservices = "web/API/reservationes/services/get_services.php";
export const getservicerules = "web/API/reservationes/services/get_rules.php";
export const setservicebooking = "web/API/reservationes/services/set_reservation.php";
export const sethandelservicebooking = "web/API/reservationes/services/handel_reservation.php";
//_______________________________________________________________________________

//                          Link Whatsapp Msg Auto
// export const UrlًWhatsappMsgInvoice = "https://system.yoursummer.ly/web/API/auto/msg_whatsapp.php";// Server
// export const UrlًInvoicePdf = 'https://system.yoursummer.ly/invoices/public/index.php';// SERVER
// export const UrlًInvoicePdf = 'http://localhost/App/Booking-System/Server/invoice_pdf/public/index.php';// DEMO
